var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAcademy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1492 20.0577V12.1762C30.1492 11.5861 29.5177 11.211 28.9996 11.4934C25.0479 13.6471 16.3553 18.3856 16.3553 18.3856C16.3553 18.3856 5.98694 12.9542 1.55116 10.5367C0.47014 9.94755 0.469868 8.3955 1.55069 7.80597C5.43345 5.68809 16.3553 0.09375 16.3553 0.09375C16.3553 0.09375 28.589 6.62422 32.449 8.72971C32.9486 9.00222 33.2595 9.52586 33.2595 10.095V20.0577C33.2595 20.9165 32.5632 21.6128 31.7044 21.6128C30.8455 21.6128 30.1492 20.9165 30.1492 20.0577Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8419 16.0014L26.7858 14.9411V24.1913C24.1268 25.8274 16.3207 30.0938 16.3207 30.0938C16.3207 30.0938 8.10785 25.9224 5.1838 24.1913L5.18359 14.7035L6.91581 15.6483C9.77417 17.2074 16.3207 20.6109 16.3207 20.6109C16.3207 20.6109 22.4462 17.3505 24.8419 16.0014Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcademy);
export default __webpack_public_path__ + "static/media/icon_academy.046665a51c44c8822b363455ce7d630a.svg";
export { ForwardRef as ReactComponent };